module.exports = __webpack_public_path__ + "assets/ic-medium.4c3bd589.svg";